import http from "@/common/http-common";
import store from "@/store";

class IssueCategoryService {
  async loadAll() {
    return http().get("/api/v1/issue_categories.json").then(function(resp) {
      console.log("Inside IssueCategoryService.loadAll, resp.data ==> ", resp.data);
      store.commit("updateIssueCategories", resp.data);
    })

  }
}

export default new IssueCategoryService();